import { render, staticRenderFns } from "./ENB_extension.vue?vue&type=template&id=2ba06112"
import script from "./ENB_extension.vue?vue&type=script&lang=js"
export * from "./ENB_extension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports